import { useEffect } from 'react';

/**
 * Custom hook for SEO management (Title and Meta Description)
 * @param {string} title - Page title
 * @param {string} description - Meta description
 */
export default function useSEO(title, description) {
  useEffect(() => {
    // Upate browser title
    if (title) {
      document.title = `${title} | BeiTec Sistemas`;
    }

    // Update meta description
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        // Create if doesn't exist (unlikely in this project)
        metaDescription = document.createElement('meta');
        metaDescription.name = "description";
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
      
      // Also update OG description for social sharing
      const ogDescription = document.querySelector('meta[property="og:description"]');
      if (ogDescription) {
        ogDescription.setAttribute('content', description);
      }
      
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.setAttribute('content', title);
      }
    }
  }, [title, description]);
}
